import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

function EnvDropDown({
	adData,
	getFocusEnv,
	theFocusEnv,
	theFocusRegion,
	theFocusCampaign
}) {
	const [focusEnv, setFocusEnv] = React.useState(theFocusEnv);
	const [allEnv, setAllEnv] = React.useState([]);

	//remove dupliates

	//create useEffect to set Env
	React.useEffect(() => {
		var env = [];

		if (theFocusCampaign && theFocusRegion) {
			// setFocusEnv("");

			adData.map((ad) => {
				if (ad.region == theFocusRegion && ad.campaign == theFocusCampaign) {
					env.push(ad.environment);
				}
			});
			env = [...new Set(env)];

			setAllEnv(env);
			setFocusEnv(theFocusEnv);
		}
	}, [theFocusRegion, theFocusCampaign]);

	// setAllCampaigns(campaigns);
	// console.log(campaigns);

	const handleChange = (event) => {
		//console.log(event.target.value);
		//send event.target.value to app.js
		getFocusEnv(event.target.value);
		const {
			target: { value }
		} = event;
		setFocusEnv(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	return (
		<div>
			<FormControl sx={{ m: 1, width: 300 }}>
				<InputLabel id="demo-multiple-checkbox-label">Environment</InputLabel>
				<Select
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					single="true"
					value={focusEnv ? focusEnv : ""}
					onChange={handleChange}
					input={<OutlinedInput label="Environment" />}
					renderValue={(selected) => selected}
					MenuProps={MenuProps}
				>
					{allEnv.map((env) => (
						<MenuItem key={env} value={env}>
							<Checkbox checked={focusEnv == env} />
							<ListItemText primary={env} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
export default EnvDropDown;
